import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia } from '../../components/imports';

const Content = () => {

  const heroRef = useRef(null);
  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          <MotionContent imgRef={heroRef} height={"h-[100vh]"} className="bg-black=">
            <ImageMedia
              key={"HeroImage"}
              src={require('./assets/Dina_Letterhead_Stationery.jpg')}
              className="md:landscape:scale-[105%] object-center"
            />
          </MotionContent>
        </div>
      )}
    </ThisProject>
  )
}

export default Content